export function deriveTierFromServiceCode(code?: string | null): string | null {
  if (!code) return null
  const normalized = code.toLowerCase()
  if (normalized.includes('field')) return 'l3_field'
  if (normalized.includes('network')) return 'l2_network'
  if (normalized.includes('remote')) return 'l1_remote'
  return 'l1_basic'
}

export function resolveServiceMeta(
  serviceTypeId: number | undefined,
  parents: Array<{ id: number; name: string; code?: string }>,
  children: Array<{ id: number; name: string; code?: string; parent_id: number }>,
): { code?: string; name?: string } {
  if (!serviceTypeId) return {}
  const child = children.find((row) => row.id === serviceTypeId)
  if (child) return { code: child.code, name: child.name }
  const parent = parents.find((row) => row.id === serviceTypeId)
  if (parent) return { code: parent.code, name: parent.name }
  return {}
}
